import { requests, mainApiRoot } from './index'

export const Tags = {
  create: (domainId, payload) => requests.post(mainApiRoot, `/domains/${domainId}/tags`, payload),
  del: (domainId, tagId) => requests.del(mainApiRoot, `/domains/${domainId}/tags/${tagId}`),
  update: (domainId, tagId, payload) =>
    requests.put(mainApiRoot, `/domains/${domainId}/tags/${tagId}`, payload),
  addTagsToKeywords: (domainId, payload) =>
    requests.put(mainApiRoot, `/domains/${domainId}/taggings/add`, payload),
  deleteTagsFromKeywords: (domainId, payload) =>
    requests.put(mainApiRoot, `/domains/${domainId}/taggings/remove`, payload)
}